module.exports = __webpack_public_path__ + "img/banner@2x.eaf69fcb.png";